// src/utils/liensFiches.ts — SCE Issues
// Fabrique les chemins des fiches détail.
//
// ─── Pourquoi centraliser ───
//
// Deux des quatre identifiants ne sont PAS sûrs dans une URL :
//
//   - le chef de projet est un nom libre venu de Windchill, avec espaces et
//     accents (« Sébastien Vautelin ») ;
//   - le numéro de série peut porter un indice de révision et des caractères
//     inattendus (« 1245-H-06 »).
//
// Oublier un encodeURIComponent à un seul endroit d'appel produit une route
// introuvable, et seulement pour certaines personnes — le genre de bogue qui
// survit longtemps. Les chemins se fabriquent donc ici, et nulle part ailleurs.
//
// ⚠️ React Router décode les paramètres de `useParams` : les pages reçoivent
// la valeur d'origine, jamais la forme encodée.

export function lienProbleme(id: string): string {
  return `/issues/${encodeURIComponent(id)}`
}

export function lienEquipement(numeroSerie: string): string {
  return `/equipements/${encodeURIComponent(numeroSerie)}`
}

export function lienProjet(pn: string): string {
  return `/projets/${encodeURIComponent(pn)}`
}

export function lienChefProjet(nom: string): string {
  return `/chefs-projet/${encodeURIComponent(nom)}`
}

/** Fiche d'une FNC-T (chantier FNC-T) : `/fnct/FNC-T_2026-58`. */
export function lienFnct(numero: string): string {
  return `/fnct/${encodeURIComponent(numero)}`
}
